import { render, staticRenderFns } from "./StudentAchievement.vue?vue&type=template&id=61996af9&scoped=true"
import script from "./StudentAchievement.vue?vue&type=script&lang=js"
export * from "./StudentAchievement.vue?vue&type=script&lang=js"
import style0 from "./StudentAchievement.vue?vue&type=style&index=0&id=61996af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61996af9",
  null
  
)

export default component.exports